import { createI18n } from 'vue-i18n'
import ru from '@/locales/ru.json'

export type MessageSchema = typeof ru

/**
 * Русские формы множественного числа: 1 минуту, 2 минуты, 5 минут. Четыре формы
 * начинаются с отдельного текста для нуля: «нет книг | {n} книга | {n} книги | {n} книг».
 */
export function russianPlural(choice: number, choicesLength: number): number {
  if (choicesLength === 4) return choice === 0 ? 0 : 1 + russianPlural(choice, 3)
  if (choicesLength < 3) return choice === 1 ? 0 : 1
  const n = Math.abs(choice) % 100
  const last = n % 10
  if (n > 10 && n < 20) return 2
  if (last === 1) return 0
  if (last >= 2 && last <= 4) return 1
  return 2
}

export const i18n = createI18n<[MessageSchema], 'ru'>({
  legacy: false,
  locale: 'ru',
  fallbackLocale: 'ru',
  messages: { ru },
  pluralRules: { ru: russianPlural },
})
